import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "spinner-overlay"
}
const _hoisted_2 = {
  "aria-hidden": "false",
  class: "fds-modal"
}
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = { class: "modal-title" }
const _hoisted_6 = { class: "modal-body" }
const _hoisted_7 = { class: "modal-footer" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", {
  id: "modal-backdrop",
  class: "modal-backdrop"
}, null, -1)
const _hoisted_9 = { key: 1 }
const _hoisted_10 = {
  role: "main",
  class: "page-container pt-0 pb-6",
  "aria-label": "Cardboard Content"
}
const _hoisted_11 = { key: 2 }
const _hoisted_12 = {
  role: "main",
  class: "page-container pt-0 pb-6",
  "aria-label": "Main Content"
}
const _hoisted_13 = {
  key: 0,
  class: "spinner-overlay"
}
const _hoisted_14 = ["aria-label"]
const _hoisted_15 = { class: "spinner-status" }
const _hoisted_16 = {
  role: "status",
  "aria-live": "polite",
  "aria-atomic": "true"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SimpleText = _resolveComponent("SimpleText")!
  const _component_RichText = _resolveComponent("RichText")!
  const _component_simple_text = _resolveComponent("simple-text")!
  const _component_Cardboard = _resolveComponent("Cardboard")!
  const _component_the_header = _resolveComponent("the-header")!
  const _component_MultipleToast = _resolveComponent("MultipleToast")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_cypress_test_element = _resolveComponent("cypress-test-element")!
  const _component_the_footer = _resolveComponent("the-footer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.versionDeprecatedPromptReload)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("h2", _hoisted_5, [
                  _createVNode(_component_SimpleText, { "text-key": "general.application-updated.header" })
                ])
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_RichText, { "text-key": "general.application-updated.message" })
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("button", {
                  class: "button button-primary",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.refreshBrowser()))
                }, [
                  _createVNode(_component_simple_text, { "text-key": "app.button.reloadandlogout" })
                ])
              ])
            ])
          ]),
          _hoisted_8
        ]))
      : _createCommentVNode("", true),
    (_ctx.showCardboard)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_Cardboard, { "cardboard-type": _ctx.cardboardSetting }, null, 8, ["cardboard-type"])
          ])
        ]))
      : (!_ctx.isFetching)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createVNode(_component_the_header),
            _createElementVNode("div", _hoisted_12, [
              (_ctx.currentPendingLoads.length > 0 || _ctx.pendingLoadsTimeout)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _createElementVNode("div", {
                      "aria-label": _ctx.contentfulContent.findSimpleText('loadspinner.general'),
                      class: "spinner"
                    }, null, 8, _hoisted_14),
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("div", _hoisted_16, [
                        _createVNode(_component_SimpleText, { "text-key": "loadspinner.general" })
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createVNode(_component_MultipleToast, {
                ref: "generalMultipleToast",
                onMultipleToastClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setNotificationShown($event)))
              }, null, 512),
              _createVNode(_component_router_view)
            ]),
            (_ctx.isTestFramework)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  id: "cypress_test_context_button",
                  onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.createTestContext()), ["prevent"])),
                  style: {"display":"none"}
                }))
              : _createCommentVNode("", true),
            (_ctx.isTestFramework)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  id: "cypress_test_forecast_button",
                  onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.createTestForecast()), ["prevent"])),
                  style: {"display":"none"}
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_cypress_test_element, {
              id: "cypress-application-state",
              type: _ctx.cypressTestSignInHost,
              inner: _ctx.cypressTestSignInState
            }, null, 8, ["type", "inner"]),
            _createVNode(_component_the_footer)
          ]))
        : _createCommentVNode("", true)
  ], 64))
}